var styleDataHash = "87f59538";
const injectCss = () => {
  var css = `.cTb-X.pJIA-{box-sizing:border-box;overflow:hidden;position:absolute;top:50px;width:100%}[dir] .cTb-X.pJIA-{padding:12px 20px}.cTb-X.pJIA- *,.cTb-X.pJIA- :after,.cTb-X.pJIA- :before{box-sizing:inherit}.cTb-X.pJIA- input{box-sizing:border-box}.wuUx7{display:flex;font-size:16px;justify-content:space-between;line-height:1.5}[dir] .wuUx7{margin-bottom:20px}.BWbuz{display:grid;grid-template-areas:"title icon"}[dir] .BWbuz{padding-top:15px}[dir=ltr] .BWbuz{padding-left:20px}[dir=rtl] .BWbuz{padding-right:20px}.ieBJR{display:flex;grid-area:icon;justify-self:end}[dir=ltr] .ieBJR{padding-right:20px}[dir=rtl] .ieBJR{padding-left:20px}@supports not (contain:inline-size){@media only screen and (min-width:940px){.bZQAO{width:280px}}}@container (min-width: 940px){.bZQAO{width:280px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_api_input_modal_default = {
  "giphy_api_input_modal_container": "cTb-X",
  "mobile": "pJIA-",
  "giphy_modal_header_container": "wuUx7",
  "giphy_api_input_modal_navbar": "BWbuz",
  "giphy_api_input_modal_closeButton": "ieBJR",
  "modalWrapper": "bZQAO"
};
export {
  giphy_api_input_modal_default as default,
  injectCss
};
//# sourceMappingURL=giphy-api-input-modal-scss.js.map
